<template>
  <div class='card card-small mb-3'>
    <div class="card-header border-bottom">
      <h6 class="m-0">Categorías</h6>
    </div>
    <div class='card-footer p-0'>
      <ul class="list-group list-group-flush">

        <li class="list-group-item px-3 pb-2" v-if="categories.length">
          <select class="form-control" @change="itemSelected">
            <option value="" selected v-if="!category">Seleciona una categoría</option>
            <option v-for="(item, index) in categories" :value="item.id" v-if="category == item.id" selected>
              {{ item.name }}
            </option>
            <option v-for="(item, index) in categories" :value="item.id" v-if="category !== item.id">
              {{ item.name }}
            </option>

          </select>
        </li>
        <li class="list-group-item d-flex px-3">
          <div class="input-group">
            <input type="text" class="form-control" placeholder="Nueva categoría" v-model="form.name">
            <div class="input-group-append">
              <button class="btn btn-white px-2" type="button" @click.prevent="addCategory">
                <i class="fas fa-plus"></i>
              </button>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="alert alert-primary" role="alert" v-if="error">
      {{ error }}
    </div>  
  </div>
</template>

<script>
  export default {
    props: ['error', 'category'],
    
    data() {
      return {
        categories: [],
        isLoaded: false,
        form: {
          name: ''
        }
      }
    },

    computed: {
      slug() {
        return this.form.name.toLowerCase().split(' ').join('_')
      }
    },

    mounted() {
      this.getCategories();
    },

    methods: {
      async getCategories() {
        let url = process.env.VUE_APP_ROOT_API.concat('/category');
        let response = await fetch(url);
        this.categories = await response.json()
        this.isLoaded = true;
      },

      itemSelected(e) {
        this.$emit('selected', e.target.value);
      },

      async addCategory() {
        let url = process.env.VUE_APP_ROOT_API.concat('/category');
        let data = {
          user_id: this.$store.state.auth.user.id,
          slug: this.slug,
          name: this.form.name
        };
        let settings = {
          method: 'POST',
          body: JSON.stringify(data),
          headers: {
            'Content-Type': 'application/json'
          }
        };
        let response = await fetch(url, settings);
        let responseData = await response.json();
        switch (response.status) {
          case 201:
            this.$toasted.show("<i class='fas fa-hashtag'></i> ¡Categoría agregada!", { 
               theme: "toasted-primary", 
               position: "top-right", 
               duration : 2000
            });
            this.categories.push(data);
            this.form.name = '';
            this.$emit('selected', responseData.id);
            break;
        }
      }
    }
  }
</script>